import { createI18n } from '@planitgeo/treeplotter-i18n';
import { defaultLang } from './config';
import enLocales from './langs/en-US';
import esLocales from './langs/es-ES';

const i18n = createI18n({
  resources: {
    en: { translations: enLocales },
    es: { translations: esLocales },
  },
  defaultLng: defaultLang.value,
});

export default i18n;
